import React from 'react';
import About from './About';
import Banner from './Banner';
import Contact from './Contact';
import Myprojects from './Myprojects';
import Services from './Services';
import Skills from './Skills';
import Xppart from './Xppart';
import Particles from 'react-tsparticles';
import { loadFull } from "tsparticles";

const Home = () => {
    const particlesInit = (engine) => {
        // console.log(engine);
        // you can initiate the tsParticles instance (engine) here, adding custom shapes or presets
        // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
        // starting from v2 you can add only the features you need reducing the bundle size
        loadFull(engine);
    };

    const particlesLoaded = (container) => {
        // await console.log(container);
    };
    return (
        <div>
            <Particles
                id="tsparticles"
                init={particlesInit}
                loaded={particlesLoaded}
                options={{
                    // background: {
                    //   color: {
                    //     value: "#0d47a1",
                    //   },
                    // },
                    fpsLimit: 50,
                    interactivity: {
                        events: {
                            onClick: {
                                enable: true,
                                mode: "push",
                            },
                            onHover: {
                                enable: true,
                                mode: "repulse",
                            },
                            resize: true,
                        },
                        modes: {
                            push: {
                                quantity: 4,
                            },
                            repulse: {
                                distance: 150,
                                duration: 0.4,
                            },
                        },
                    },
                    particles: {
                        color: {
                            value: "#ffffff",
                        },
                        links: {
                            color: "#ffffff",
                            distance: 150,
                            enable: true,
                            opacity: 0.4,
                            width: 1,
                        },
                        collisions: {
                            enable: true,
                        },
                        move: {
                            directions: "none",
                            enable: true,
                            outModes: {
                                default: "bounce",
                            },
                            random: false,
                            speed: 2,
                            straight: false,
                        },
                        number: {
                            density: {
                                enable: true,
                                area: 800,
                            },
                            value: 40,
                        },
                        opacity: {
                            value: 0.4,
                        },
                        shape: {
                            type: "circle",
                        },
                        size: {
                            value: { min: 1, max: 5 },
                        },
                    },
                    detectRetina: true,
                }}
            />
            <Banner></Banner>
            <Skills></Skills>
            <Myprojects></Myprojects>
            <Services></Services>
            <Xppart></Xppart>
            <About></About>
            <Contact></Contact>
        </div>
    );
};

export default Home;